module.exports = __webpack_public_path__ + "static/media/music-sheet-g17e2fb2e5_640.983e729f.jpg";